import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Modal, ModalBody, ModalFooter, TabContent, TabPane, FormGroup, Badge, Label, Input, InputGroup, InputGroupText, Button, ButtonGroup } from 'reactstrap';
import LaddaButton, { EXPAND_LEFT } from 'react-ladda';

import Config from '../../config';
import Lang from '../../languages';

import './Editor.css';


class TicketEditor extends Component {
 constructor(props) {
  super(props);

  this.setValue = this.setValue.bind(this);
  this.handleSave = this.handleSave.bind(this);
  this.handleClose = this.handleClose.bind(this);
  this.handleQuantities = this.handleQuantities.bind(this);

  this.state = {
   laddaloading: false,
   errMessage: false,
   failedCodes: [],
   editorMode: false
  }
 }

 resetAll() {
  var classNames = {}
  var orderValues = { eventID: 0, packets: null, documentID: '', full_name: '', email: '', phone: '', language: this.props.session.language }
  Object.keys(orderValues).map(function (key, value) { classNames[key] = "form-control" });
  this.setState({
   activeTab: '1',
   titleTab: Lang[this.props.session.language].Tickets.titles.editorTab1,
   laddaloading: false,
   errMessage: false,
   editorMode: false,
   order: orderValues,
   packets: [],
   classNames
  })
 }

 setValue(e) {
  var order = this.state.order;
  order[e.target.id] = e.target.value;
  this.setState({ order });
 }


 handleSave() {
  var errorFileds = this.state.classNames;
  Object.keys(errorFileds).map(function (key, index) { errorFileds[key] = errorFileds[key].replace(' border border-danger', ''); });
  this.setState({ laddaloading: true, classNames: errorFileds });
  this.props.reqAPI(Config.apiURI + '/api/tickets', 'PUT', this.state.order).then((result) => {
   if (result.success) {
    this.props.onComplete(true);
    this.resetAll();
   } else {
    var errorFileds = this.state.classNames;
    result.failed.map((key) => { errorFileds[key] = errorFileds[key] + " border border-danger"; });
    this.setState({
     laddaloading: false,
     errMessage: result.message,
     failedCodes: result.codes ? result.codes : [],
     classNames: errorFileds
    });
   }
  }).catch((error) => {
   console.error(error);
   this.setState({ laddaloading: false });
  })
 }

 handleClose() {
  this.props.handleClose();
  this.resetAll();
 }

 handleTabs(tab) {
  switch (tab) {
   case '1': var title = Lang[this.props.session.language].Tickets.titles.editorTab1; break;
   case '2': var title = Lang[this.props.session.language].Tickets.titles.editorTab2; break;
  }

  this.setState({ titleTab: title, activeTab: tab });
 }

 handleQuantities(event) {
  var packetID = event.currentTarget.id;
  var packetQt = parseInt(event.currentTarget.value);
  var order = this.state.order;
  var packets = this.state.packets;
  
  packets.map((pkg, key) => {
   if(pkg.ID == packetID) packets[key].quantity = packetQt;
  })

  
  if(!order.packets) order.packets = {};
  order.packets[packetID] = packetQt;
  this.setState({ order, packets });
 }

 componentWillMount() {
  this.resetAll();
 }

 componentWillUpdate() {
  if (this.props.event != null && !this.state.editorMode) {
   this.setState({
    editorMode: true,
    packets: this.props.event.packets ? this.props.event.packets : [],
    order: {
     ...this.state.order,
     eventID: this.props.event.ID ? this.props.event.ID : ''
    }
   });
  }
 }

 render() {
  var total = 0;
  return (
   <Modal className="modal-lg ModalTicket" isOpen={this.props.open}>

    <CardHeader>
     <i className="fa fa-address-book-o"></i><strong>{this.state.titleTab}</strong>
     <div className="card-actions bg-light">
      <Button disabled={true}><i className="fa fa-packet"></i></Button>
     </div>
    </CardHeader>

    <ModalBody>
     {
      this.state.packets.map((packet, key) => {
       if(!packet.quantity) packet.quantity = 0;
       total = total + (packet.quantity * packet.price);
       return (
        <div key={key} className="mt-0 mb-0">
         <CardBody className="p-1">
         <FormGroup className="p-0" check>
           <Label check>
            <Input addon id={packet.ID} type="input" value={packet.quantity} style={{width:'30px',height:'22px',padding:'1px 2px 2px 2px',marginRight:'5px',float:'left',textAlign:'center'}} name="packet" onChange={this.handleQuantities} disabled={!packet.available} />{' '}
            <strong>{packet.name[this.props.session.language]}</strong> - {packet.price}&euro;{' '}
            <small>({
           packet.tickets.map((ticket, key) => {
            return (
             <span key={key}>{ticket.name[this.props.session.language]}{(key+1) < packet.tickets.length?', ':''}</span>
            )
           })
          })</small>
           </Label>
          </FormGroup>
         </CardBody>
        </div>
       )
      })
     }
     {
      <Badge pill color={total>0?'primary':'light'} className="text-white">Total: {total}&euro;</Badge>
     }
    </ModalBody>
    
    <ModalBody>
     <FormGroup row>
      <Col xs="8">
       <FormGroup className="form-group-clean">
        <Label htmlFor="full_name">{Lang[this.props.session.language].Tickets.columns.full_name}</Label>
        <Input type="text" id="full_name" autoComplete="off" value={this.state.order.full_name} onChange={(e) => { this.setValue(e) }} placeholder={Lang[this.props.session.language].Tickets.placeholders.full_name} className={this.state.classNames.full_name} />
       </FormGroup>
      </Col>
      <Col xs="4">
       <FormGroup className="form-group-clean">
        <Label htmlFor="documentID">{Lang[this.props.session.language].Tickets.columns.documentID}</Label>
        <Input type="text" id="documentID" autoComplete="off" value={this.state.order.documentID} onChange={(e) => { this.setValue(e) }} placeholder={Lang[this.props.session.language].Tickets.placeholders.documentID} className={this.state.classNames.documentID} />
       </FormGroup>
      </Col>
     </FormGroup>

     <FormGroup row>
      <Col xs="6">
       <FormGroup className="form-group-clean">
        <Label htmlFor="email">{Lang[this.props.session.language].Tickets.columns.email}</Label>
        <Input type="text" id="email" autoComplete="off" value={this.state.order.email} onChange={(e) => { this.setValue(e) }} placeholder={Lang[this.props.session.language].Tickets.placeholders.email} className={this.state.classNames.email} />
       </FormGroup>
      </Col>

      <Col xs="3">
       <FormGroup className="form-group-clean">
        <Label htmlFor="phone">{Lang[this.props.session.language].Tickets.columns.phone}</Label>
        <Input type="text" id="phone" autoComplete="off" value={this.state.order.phone} onChange={(e) => { this.setValue(e) }} placeholder={Lang[this.props.session.language].Tickets.placeholders.phone} className={this.state.classNames.phone} />
       </FormGroup>
      </Col>

      <Col xs="3">
       <FormGroup className="form-group-clean">
        <Label htmlFor="language">{Lang[this.props.session.language].Users.columns.language}</Label>
        <Input id="language" name="select" type="select" onChange={this.setValue} value={this.state.order.language} className={this.state.classNames.language}>
         {
          Object.keys(Lang[this.props.session.language].languages).map((key, index) => {
           return (<option key={index} value={key}>{Lang[this.props.session.language].languages[key]}</option>)
          })
         }
        </Input>
       </FormGroup>
      </Col>
     </FormGroup>
    </ModalBody>

    <ModalFooter>
     <div className="text-danger"><strong>{this.state.errMessage}</strong></div>
     <Button color="danger" onClick={this.handleClose}>{Lang[this.props.session.language].Tickets.buttons.closeEditor}</Button>
     <LaddaButton
      type="submit"
      onClick={this.handleSave}
      className="btn btn-success btn-ladda"
      data-style={EXPAND_LEFT}
      loading={this.state.laddaloading}>
      {Lang[this.props.session.language].Tickets.buttons.createBtn}
     </LaddaButton>
    </ModalFooter>
   </Modal>
  )
 }

}

export default TicketEditor;



// WEBPACK FOOTER //
// ./websources/views/Tickets/Editor.js